/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Deep_P2Inputs */

const en_formatter_deep_p2 = /** @type {(inputs: Formatter_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integers larger than 2 to the 53rd power cannot be held exactly in a double, so they are the one case where formatting genuinely loses information. Paste 12345678901234567890 and the output reads 12345678901234567000. If your payload carries large IDs, snowflake identifiers, or currency values as bare numbers, treat any JSON tool that round trips through a native parser as unsafe for those fields, this one included. Sending such IDs as strings is the usual fix, and it is worth doing at the API level.`)
};

const ko_formatter_deep_p2 = /** @type {(inputs: Formatter_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2의 53승보다 큰 정수는 double에 정확히 담기지 않으므로, 포매팅이 실제로 정보를 잃는 유일한 경우입니다. 12345678901234567890을 넣으면 출력은 12345678901234567000이 됩니다. 페이로드가 큰 ID, 스노플레이크 식별자, 또는 통화 값을 순수 숫자로 담고 있다면, 네이티브 파서를 왕복하는 모든 JSON 도구를 그 필드에 대해 안전하지 않다고 봐야 합니다. 이 도구도 포함됩니다. 그런 ID를 문자열로 보내는 것이 통상적인 해법이며, API 수준에서 처리할 만한 가치가 있습니다.`)
};

const ja_formatter_deep_p2 = /** @type {(inputs: Formatter_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 の 53 乗より大きい整数は double に正確に収まらないため、整形が実際に情報を失う唯一のケースです。12345678901234567890 を入れると出力は 12345678901234567000 になります。ペイロードが大きな ID、スノーフレーク識別子、通貨の値を素の数値で持っているなら、ネイティブパーサを往復するすべての JSON ツールは、そのフィールドについて安全でないと考えるべきです。このツールも含みます。そうした ID を文字列で送るのが通常の解決策で、API のレベルで対応する価値があります。`)
};

/**
* | output |
* | --- |
* | "Integers larger than 2 to the 53rd power cannot be held exactly in a double, so they are the one case where formatting genuinely loses information. Paste 123..." |
*
* @param {Formatter_Deep_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_deep_p2 = /** @type {((inputs?: Formatter_Deep_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Deep_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_deep_p2(inputs)
	if (locale === "ko") return ko_formatter_deep_p2(inputs)
	return ja_formatter_deep_p2(inputs)
});